import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { CommunityService } from '../../services/community/community.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environment';

@Component({
    selector: 'app-view-community',
    templateUrl: './view-community.component.html',
    styleUrls: ['./view-community.component.scss'],
    standalone: false
})
export class ViewCommunityComponent implements OnInit {
  communityName: string = '';
  communityId: number | null = null;
  communityCode: string = '';
  invitationWebpageLink: string = '';
  surveyWebpageLink: string = '';
  servicesWebpageLink: string = '';

  constructor(private communityService: CommunityService,
    private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.communityId = Number(this.route.snapshot.paramMap.get('id')) || null;
    this.getCommunityDetails();
  }

  getCommunityDetails() {
    if (this.communityId) {
      this.communityService.getCommunity(this.communityId).subscribe((data) => {
        const community = data?.data;
        if (community) {
          this.communityName = community.title || '';
          this.communityCode = community.code || '';
          this.invitationWebpageLink = community.invitation_webpage_link || '';
          this.surveyWebpageLink = community.survey_webpage_link || '';
          this.servicesWebpageLink = this.generateServicesLink(this.communityCode);
        }
      });
    }
  }

  generateServicesLink(code: string): string {
    if (!code) {
      return '';
    }
    
    const baseUrl = environment.AYEN_WEB_URL;
    
    const params = new URLSearchParams({
      utm_source: 'webinar',
      utm_campaign: code
    });
    
    return `${baseUrl}/services?${params.toString()}`;
  }
}
